export default __webpack_public_path__ + "static/media/xray-collapse-active.c7aca964.svg";